export const FLEXIBLE_REPORT_REQUEST_TAG = 'Flexible Report Request';

export const TAGS = [FLEXIBLE_REPORT_REQUEST_TAG];
